import { Button, Diferencas } from "./style";
import {FiArrowUpRight} from "react-icons/fi"
import {BsFillCheckCircleFill} from "react-icons/bs"


function DiferencasComponent() {
  return (
    <Diferencas id="osdiferenciais" checked={<BsFillCheckCircleFill/>}>
      <div id="pather-div">
        
        <div id="div-two">
          <span id="span-pq">o por quê me escolher?</span>
          <h1 id="h1-desktop">Veja ao lado como eu me diferencio dos outros:</h1>
          <h1 id="h1-mobile">Veja abaixo como eu me diferencio dos outros:</h1>
          <p>
            <span>Eu garanto o resultado, mas para isso acontecer, você terá que
            mudar.</span><br /> Você não vai aprender como sempre aprendeu, então é preciso
            se conhecer, saber como age e reage e aprender a estudar, por isso
            aplicamos o Mapeamento Comportamental. <br /><br />
            Você terá que criar novos hábitos e estabelecer novos comportamento.
            <br /><br />
            Ahhh, e não estamos falando somente do aprendizado de um segundo
            idioma, tá? <span>Isso também vai servir para sua vida!</span>{" "}
          </p>
          <Button w="320px" h="56px" s="14px" icon="20px" id="button-desktop"><a target="blank" href="https://api.whatsapp.com/send?phone=5511940579505&text=Gostaria%20de%20falar%20sobre">Eu quero falar inglês <FiArrowUpRight /></a></Button>
        </div>
        <div id="div-one">
          <p id="subtitle">
            São diversos benefícios que vão te ajudar a chegar no seu objetivo.
          </p>
          <article>
            <p><BsFillCheckCircleFill className="icon-checked"/><p><span>Aulas ao vivo e não gravadas;</span></p>
            </p>
            <p><BsFillCheckCircleFill className="icon-checked"/><p><span>
                  Programa de inglês com a sua cara, com o que você precisa e
                  sua necessidade;
                </span></p>
            </p>
            <p><BsFillCheckCircleFill className="icon-checked"/><p><span>Processo Comportamental&#169;:</span> Entendimento, definição de
                estratégia, planejamento e execução;</p>
            </p>
            <p><BsFillCheckCircleFill className="icon-checked"/><p><span>Revisão do Processo:</span> Avaliação de desempenho,
                análise de resultados, ajuste de rota e retomada.</p>
            </p>
            <p><BsFillCheckCircleFill className="icon-checked"/><p><span>Bônus - Mapeamento de Perfil Comportamental:</span> Quando
                você se conhece, sabe suas fortalezas e pontos de melhoria, seus
                desafios se tornam mais tranquilos e menos trabalhosos;</p>
            </p>
          </article>
          <Button w="256px" h="40px" s="12px" icon="16px" id="button-mobile"><a target="blank" href="https://api.whatsapp.com/send?phone=5511940579505&text=Gostaria%20de%20falar%20sobre">Eu quero falar inglês <FiArrowUpRight /></a></Button>
        </div>
      </div>
    </Diferencas>
  );
}

export default DiferencasComponent;
